import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Pillars", href: "#pillars" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Column", href: "#column" },
  { label: "Vaarta", href: "#vaarta" },
  { label: "Join", href: "#join" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    window.__lenis
      ? window.__lenis.scrollTo(href, { offset: -20, duration: 1.6 })
      : document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.4 }}
      className={`fixed top-0 left-0 right-0 z-40 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-samatva-cream/85 backdrop-blur-md border-b border-samatva-line"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-12 py-4">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          data-testid="nav-logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src="/samatva-logo.jpeg"
            alt="Samatva logo"
            className="w-10 h-10 rounded-full object-cover mix-blend-multiply transition-transform duration-500 group-hover:rotate-[15deg]"
          />
          <span className="font-serif text-xl tracking-[0.25em] text-samatva-ink">
            SAMATVA
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-samatva-muted hover:text-samatva-ink transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-samatva-plum after:transition-[width] after:duration-300 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#join"
            onClick={(e) => go(e, "#join")}
            data-testid="nav-join-button"
            className="text-sm px-5 py-2 rounded-full bg-samatva-ink text-samatva-cream hover:bg-samatva-plum transition-colors duration-300"
          >
            Join the circle
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-samatva-ink"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-samatva-cream/95 backdrop-blur-md border-b border-samatva-line px-6 py-6 flex flex-col gap-4"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="font-serif text-2xl text-samatva-ink"
            >
              {l.label}
            </a>
          ))}
        </motion.div>
      )}
    </motion.header>
  );
};
